import { render, staticRenderFns } from "./AddNormalizedNameDialog.vue?vue&type=template&id=b98a64d2"
import script from "./AddNormalizedNameDialog.vue?vue&type=script&lang=js"
export * from "./AddNormalizedNameDialog.vue?vue&type=script&lang=js"
import style0 from "./AddNormalizedNameDialog.vue?vue&type=style&index=0&id=b98a64d2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports